module.exports = __webpack_public_path__ + "static/how-it-works-2-cf84a877de6ab4f616084cf1c1cf2f92.png";